import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 11c-1.773 0-3.352.065-4.642.147a2.38 2.38 0 0 0-2.252 2.226A37 37 0 0 0 5 16c0 .852.043 1.763.106 2.627a2.38 2.38 0 0 0 2.252 2.226 74 74 0 0 0 9.284 0 2.38 2.38 0 0 0 2.252-2.226c.063-.864.106-1.775.106-2.627s-.044-1.763-.106-2.627a2.38 2.38 0 0 0-2.252-2.226A74 74 0 0 0 12 11M7.232 9.15a4.38 4.38 0 0 0-4.12 4.079A39 39 0 0 0 3 16c0 .915.047 1.877.111 2.771a4.38 4.38 0 0 0 4.12 4.078 76 76 0 0 0 9.538 0 4.38 4.38 0 0 0 4.12-4.078c.064-.894.111-1.856.111-2.771s-.047-1.877-.111-2.771a4.38 4.38 0 0 0-4.12-4.078 76 76 0 0 0-9.537 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 16.732A2 2 0 0 0 12 13a2 2 0 0 0-1 3.732V18a1 1 0 1 0 2 0zM7 6a5 5 0 0 1 10 0v4a1 1 0 1 1-2 0V6a3 3 0 1 0-6 0v4a1 1 0 1 1-2 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }